import { useSelector, useDispatch } from "react-redux";
import {
  closeModal,
  next,
  openModal,
  previous,
  setSearchTerm,
} from "../../features/findInPage/FindInPageSlice";
import { useEffect } from "react";
import { scrollToMatch } from "./findInPage";

export function useFindInPage() {
  const { searchTerm, isOpen, activeIndex, totalMatch } = useSelector(
    (state) => state.findInPage,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && activeIndex >= 0) {
      scrollToMatch(activeIndex);
    }
  }, [activeIndex]);

  return {
    value: searchTerm,
    updateSearchTerm: (term) => dispatch(setSearchTerm(term)),
    openModal: () => dispatch(openModal()),
    closeModal: () => dispatch(closeModal()),
    next: () => dispatch(next()),
    previous: () => dispatch(previous()),
    isOpen,
    activeIndex,
    totalMatch,
  };
}
